import { LiveAnnouncer } from '@angular/cdk/a11y';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OrdenServicioModel } from 'src/app/model/file/model.file';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-notas-credito-proveedores',
  templateUrl: './notas-credito-proveedores.component.html',
  styleUrls: ['./notas-credito-proveedores.component.css']
})
export class NotasCreditoProveedoresComponent implements OnInit {


  startDate: Date | any;
  endDate: Date | any;

  startDateSelected: Date | any;
  endDateSelected: Date | any;

  data: any;

  selectFile: string | null = null;
  selectProveedor: string | null = null;
  selectOS: string | null = null;
  selectEstado: string | null = null;

  arrayFiles: any = [];
  arrayProveedores: any = [];
  arrayOS: any = [];
  arrayEstado: any = [];

  loader: boolean = false

  dataSource = new MatTableDataSource<any>();

  displayedColumns: string[] =
    ['codigo', 'estado', 'nameProveedor', 'reef', 'saf', 'penalidad', 'moneda',"partialPayment", 'fileNumber', 'numberOS', 'createdAt'];

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.dataSource.sort = value;
  }


  constructor(private fileService: FileService,) { }

  ngOnInit(): void {
    this.loader = true
    this.getAllNCP();
  }

  async getAllNCP() {
    this.fileService.getAllNotasCreditoProveedores().subscribe(async result => {

      console.log(result)
      const resultData = result.getAllNotasCreditoProveedores

      const files = resultData.map((item: any) => (item.fileNumber))
      const proveedores = resultData.map((item: any) => (item.nameProveedor))
      const os = resultData.map((item: any) => (item.numberOS))
      const estadoOS = resultData.map((item: any) => (item.estado))

      this.arrayFiles = [...new Set(files)]
      this.arrayProveedores = [...new Set(proveedores)]
      this.arrayOS = [...new Set(os)]
      this.arrayEstado = [...new Set(estadoOS)]

      this.data = resultData
      this.dataSource.data = resultData;
      this.dataSource.paginator = this.paginator;
      //this.dataSource.data = result
      this.loader = false;
    }
    )

  }

  applyFilter(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }


  applyFilterSelect() {

    let dataNew: any = this.data

    if (this.startDateSelected && this.endDateSelected) {
      dataNew = dataNew?.filter((item: any) => {

        console.log(new Date(item.createdAt))

        return new Date(this.startDateSelected) <= new Date(item.createdAt) && new Date(item.createdAt) <= new Date(this.endDateSelected)
      })

    }

    if (this.selectFile) {
      dataNew = dataNew?.filter((item: any) => item.fileNumber === this.selectFile)
    }
    if (this.selectProveedor) {
      dataNew = dataNew?.filter((item: any) => item.nameProveedor === this.selectProveedor)
    }

    if (this.selectEstado) {
      dataNew = dataNew?.filter((item: any) => item.estado === this.selectEstado)
    }
    if (this.selectOS) {
      dataNew = dataNew?.filter((item: any) => item.numberOS === this.selectOS)
    }

    this.dataSource.data = dataNew

  }

  onApplyRangeSelected() {
    console.log(this.startDate)

    this.startDateSelected = this.getDateTransform(JSON.stringify(new Date(this.startDate)))
    this.endDateSelected = this.getDateTransform(JSON.stringify(new Date(this.endDate)))
    this.applyFilterSelect()
  }


  getDateTransform(date: string) {
    console.log("date", date)
    if (date) {
      const dateSeparated = date?.slice(1, 11).split('-')
      console.log(dateSeparated)
      const month = dateSeparated[1]
      const day = dateSeparated[2]
      const year = dateSeparated[0]
      return month + '/' + day + '/' + year
    }
    return null;
  }

  transformFormat(date: string) {
    if (date) {
      const dateSeparated = date?.slice(0, 10).split('-')
      console.log(dateSeparated)
      const month = dateSeparated[1]
      const day = dateSeparated[2]
      const year = dateSeparated[0]
      return month + '/' + day + '/' + year
    }
    return null;

  }

  cleanDateSelected(val: any) {

    console.log(val)
    if (val == 1) {
      this.startDate = null
      this.startDateSelected = null
      this.endDate = null
      this.endDateSelected = null
    }

    this.applyFilterSelect()

  }

}
